type FooterCopyrightProps = {
  testId?: string;
  subPublication?: string;
};

// Year is hardcoded (not `new Date().getFullYear()`) to keep the SSR and client
// initial render identical and avoid a React #418 hydration mismatch when the
// SSR clock and client clock disagree (e.g. VRT runs that mock only the browser
// clock via Playwright's page.clock). The MDDI permit number immediately
// preceding it ("…/04/2025") is also hardcoded and updated annually when the
// permit is renewed — update both together.
const COPYRIGHT_YEAR = "2025";

export function FooterCopyright({
  testId,
  subPublication = "",
}: FooterCopyrightProps) {
  return (
    <div
      data-testid={`${testId}-copyright`}
      className="not-italic text-2sm tracking-normal leading-400 text-gray-100"
    >
      {`MDDI (P) ${
        subPublication === "balar-murasu" ? "003" : "001"
      }/04/${COPYRIGHT_YEAR}. SPH Digital News Copyright © ${COPYRIGHT_YEAR}. SPH Media Limited. Co. Regn. No. 202120748H. All Rights Reserved.`}
    </div>
  );
}
